// extracted by mini-css-extract-plugin
export default {"wrapper":"rha","container":"sha","box":"tha","title":"uha","rdwrap":"vha","rditem":"wha","rdimage":"xha","name":"yha","heading":"zha","text":"Aha","guarantee":"Bha","chatbox":"Cha"};
    if(module.hot) {
      // 1726593108549
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  